<template>
  <div id="header-user">
    <a class="user-btn" v-if="!userInfo" @click="openLogin">
      <img src="@/assets/user.png">
    </a>
    <template v-else>
      <img class="user-avatar" :src="userInfo.avatar"/>
      <span class="user-name">{{ userInfo.nickname }}</span>
      <ul class="user-submenu">
        <li>
          <router-link to="/user/userInfo">
            <i class="iconfont icongerenzhongxin"/> 个人中心
          </router-link>
        </li>
        <li>
          <a @click="logout"><i class="iconfont icontuichu"/> 退出</a>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import {logout} from "@/api/user";
import {removeToken, removeLocalUserInfo} from "@/utils/auth";

export default {
  name: "header-user",
  data() {
    return {
      userInfo: this.$store.state.userInfo
    }
  },
  watch: {
    "$store.state.userInfo": {
      handler: function () {
        this.userInfo = this.$store.state.userInfo
      }
    }
  },
  created() {
  },
  methods: {
    openLogin() {
      this.$store.dispatch('setLoginDialog', true);
    },
    logout() {
      logout().then(res => {
        console.log(res.message);
        removeToken();
        removeLocalUserInfo();
        this.userInfo = null;
        const currentRoute = this.$router.currentRoute.fullPath;
        if (currentRoute !== '/') {
          this.$router.push({path: '/'});
        }
        this.$message.success("注销成功");
      }).catch(err => {
        console.log(err)
      });
    }
  }
}
</script>

<style scoped lang="less">
.user-btn img, .user-avatar {
  width: 40px;
  height: 40px;
}

.user-name {
  padding-left: 8px;
  position: relative;
  top: -15px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.user-avatar {
  cursor: pointer;
  border-radius: 50%;
  border: 2px solid rgba(13, 148, 136, 0.25);
  transition: all 0.25s ease;
}

.user-avatar:hover {
  border-color: #14b8a6;
  box-shadow: 0 2px 10px rgba(13, 148, 136, 0.3);
}

#header-user:hover .user-submenu {
  display: block;
}

.user-submenu {
  position: absolute;
  display: none;
  right: 0;
  width: 130px;
  margin-right: 30px;
  margin-top: 10px;
  padding: 6px;
  border-radius: 10px;
  border: 1px solid rgba(13, 148, 136, 0.15);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  background-color: #fff;
  animation: submenu 0.3s 0.1s ease both;
  z-index: 10;
}

.user-submenu:before {
  position: absolute;
  top: -10px;
  left: 0;
  width: 100%;
  height: 20px;
  content: "";
}

.user-submenu li {
  border-radius: 6px;
  overflow: hidden;
}

.user-submenu a {
  line-height: 2.2;
  color: var(--text-secondary) !important;
  text-shadow: none;
  display: block;
  padding-left: 14px;
  font-size: 13px;
  text-decoration: none;
  transition: all 0.2s ease;
}

.user-submenu a:hover {
  background: #f0fdfa;
  color: #0d9488 !important;
}

ul {
  list-style: none;
}

</style>
